module.exports = __webpack_public_path__ + "static/media/centrality.34b51eb0.png";